// assets
import { LoginOutlined, RollbackOutlined } from '@ant-design/icons';

// icons
const icons = {
  LoginOutlined,
  RollbackOutlined
};

// ==============================|| MENU ITEMS - AUTHENTICATION ||============================== //

const pages = {
  id: 'authentication',
  title: 'Authentication',
  type: 'group',
  children: [
    {
      id: 'login1',
      title: 'Login',
      type: 'item',
      url: '/login',
      icon: icons.LoginOutlined,
      target: true
    },
    {
      id: 'areas',
      title: 'Areas',
      type: 'item',
      get url() {
        try {
          const p = typeof window !== 'undefined' ? window.location?.pathname || '' : '';
          if (p.startsWith('/i')) return '/areas/iberdrola';
          if (p.startsWith('/familias/')) return '/areas/gestion';
          if (p.startsWith('/areas/plan-estrategico')) return '/areas/plan-estrategico';
          if (p.startsWith('/areas/portal-usuario')) return '/areas/portal-usuario';
        } catch {}
        try {
          const a = localStorage.getItem('current_area');
          if (a === 'i') return '/areas/iberdrola';
          if (a && a.startsWith('familia-')) return '/areas/gestion';
          if (a === 'plan-estrategico') return '/areas/plan-estrategico';
          if (a === 'portal-usuario') return '/areas/portal-usuario';
        } catch {}
        return '/areas';
      },
      exact: true,
      icon: icons.RollbackOutlined
    }
  ]
};

export default pages;
